/**
 * Whether the merchant dashboard shows the Front chat (BBS-406): absent or
 * `null` = the default, shown; `false` = hidden by Care from the super admin.
 * The one place the office reads this rule: keep it in line with
 * `PLAN_FIELDS.chatSupport.isOnByDefault` on the server.
 */
export function isChatSupportEnabled(
  plan: { chatSupport?: boolean | null } | null | undefined,
): boolean {
  return plan?.chatSupport !== false;
}
